import { useEventCallback } from '@cian/react-utils';
import { Button } from '@cian/ui-kit';
import * as React from 'react';

export interface IShowContactsButtonProps {
  onClick(): void;
}

export const ShowContactsButton: React.FC<IShowContactsButtonProps> = ({ onClick }) => {
  const handleClick = useEventCallback(() => {
    onClick();
  });

  return (
    <Button size="M" fullWidth onClick={handleClick}>
      Показать контакты
    </Button>
  );
};
